import styled from 'styled-components';
import { BodyBoldS, BodyRegularS } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const ContentCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    padding:
      ${theme.layout.spacing.decy}
      ${theme.layout.spacing.decy}
      ${theme.layout.spacing.tera};
  `}
`;

export const ContentText = styled(BodyBoldS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const ContentSubText = styled(BodyRegularS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
    display: block;
    margin-top: ${theme.layout.spacing.decy};
  `}
`;
